import {
	ACCOUNT as SET_ACCOUNT,
	USER as SET_USER,
	CRITICAL_ERROR as SET_CRITICAL_ERROR,
	LANGUAGE as SET_LANGUAGE,
	BRAND_PREVIEW,
	CUSTOMER,
	AUTHENTICATED,
	ACCOUNT_READY,
	ACCOUNT_META,
	IMPERSONATE_USER,
	SET_SESSION_ID
} from "./actions";
import { reducer as TaskBarReducer } from "./data/taskbar/reducer";
import { reducer as usageReducer } from "./data/usage/reducer";

import _ from "lodash";

let initialState = () => {
	return {
		account: null,
		impersonatingUser: false,
		customer: null,
		user: null,
		previousPath: null,
		criticalError: null,
		language: null,
		previewingBrand: false,

		authenticated: null,
		accountReady: false,

		accountMetaData: {},

		sessionId:null
	};
};

export const reducer = (state = initialState(), action) => {
	const rest = _.omit(state, Object.keys(initialState()));
	switch (action.type) {
		case SET_ACCOUNT:
			return { ...state, account: action.account };
		case SET_SESSION_ID:
			return { ...state, sessionId: action.sessionId };
		case CUSTOMER:
			return { ...state, customer: action.customer };
		case SET_USER:
			return { ...state, user: action.user };
		case SET_CRITICAL_ERROR:
			return { ...state, criticalError: action.criticalError };
		case SET_LANGUAGE:
			return { ...state, language: action.language };
		case BRAND_PREVIEW:
			return { ...state, previewingBrand: action.preview };
		case AUTHENTICATED:
			return { ...state, authenticated: action.authenticated };
		case ACCOUNT_READY:
			return { ...state, accountReady: action.accountReady };
		case IMPERSONATE_USER:
			return { ...state, impersonatingUser: action.impersonating };
		case ACCOUNT_META:
			return {
				...state,
				accountMetaData: {
					...state.accountMetaData,
					[action.name]: action.accountMetaData,
				},
			};
		default:
			return {
				...state,
				taskBar: TaskBarReducer(rest.taskBar, action),
				usage: usageReducer(rest.usage, action),
			};
	}
};
